import script from "./mediaDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./mediaDetail.vue?vue&type=script&lang=ts&setup=true"

import "./mediaDetail.vue?vue&type=style&index=0&id=7cc9f3f1&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cc9f3f1"]])

export default __exports__